import store from '../../../core/store';

export const listTimesheets = () => {
  return store.dispatch({
    action: 'table.timesheets/LIST_TIMESHEETS',
    method: 'GET',
    endpoint: '/user_timesheets',
    main: true,
  });
};

export const readTimesheet = (id) => {
  return store.dispatch({
    action: 'table.timesheets/READ_TIMESHEET',
    method: 'GET',
    endpoint: '/user_timesheets/' + id,
  });
};

export const readUserLeave = (uuid) => {
  return store.dispatch({
    action: 'table.timesheets/READ_USER_LEAVE',
    method: 'GET',
    endpoint: '/user_leaves/' + uuid,
  });
};

export const createTimesheet = (formData) => {
  return store.dispatch({
    action: 'table.timesheets/CREATE_TIMESHEET',
    method: 'POST',
    endpoint: '/user_timesheets',
    data: formData,
  });
};

export const createTimeOff = (formData) => {
  return store.dispatch({
    action: 'table.timesheets/CREATE_TIMEOFF',
    method: 'POST',
    endpoint: '/user_leaves',
    data: formData,
  });
};

export const editTimesheet = (id, timesheetData) => {
  return store.dispatch({
    action: 'table.timesheets/EDIT_TIMESHEET',
    method: 'PUT',
    endpoint: `/user_timesheets/${id}`,
    data: timesheetData,
  });
};

export const editUserLeave = (uuid, userLeaveData) => {
  return store.dispatch({
    action: 'table.timesheets/EDIT_USER_LEAVE',
    method: 'PUT',
    endpoint: `/user_leaves/${uuid}`,
    data: userLeaveData,
  });
};

export const deleteTimesheet = (id) => {
  return store.dispatch({
    action: 'table.timesheets/DELETE_TIMESHEET',
    method: 'DELETE',
    endpoint: '/user_timesheets/' + id,
  });
};

export const deleteUserLeave = (id) => {
  return store.dispatch({
    action: 'table.timesheets/DELETE_USER_LEAVE',
    method: 'DELETE',
    endpoint: '/user_leaves/' + id,
  });
};

export const listPossibleWorkSites = () => {
  return store.dispatch({
    action: 'table.timesheets/LIST_POSSIBLE_WORK_SITES',
    method: 'GET',
    endpoint: '/address_book_companies/list_possible',
  });
};

export const listPossibleLeaveReasons = () => {
  return store.dispatch({
    action: 'table.timesheets/LIST_POSSIBLE_LEAVE_REASONS',
    method: 'GET',
    endpoint: '/user_leaves/list_possible_leave_reasons',
  });
};

export const listPossibleLeaveParticipants = () => {
  return store.dispatch({
    action: 'table.timesheets/LIST_POSSIBLE_LEAVE_PARTICIPANTS',
    method: 'GET',
    endpoint: '/user_leaves/list_possible_leave_participants',
  });
};

export const listWeekViewParticipants = () => {
  return store.dispatch({
    action: 'table.timesheets/LIST_POSSIBLE_WEEK_VIEW_PARTICIPANTS',
    method: 'GET',
    endpoint: '/user_week_view/list_possible_users',
  });
};

export const handleLeaveApproval = (url, type) => {
  return store.dispatch({
    action: `table.timesheets/HANDLE_LEAVE_APPROVAL_${type.toUpperCase()}`,
    method: 'GET',
    endpoint: url,
  });
};

export const readLeaveApprovalStatus = (url) => {
  return store.dispatch({
    action: 'table.timesheets/READ_LEAVE_APPROVAL_STATUS',
    method: 'GET',
    endpoint: url,
    preloaded: false,
  });
};
